export default __webpack_public_path__ + "static/media/webhooks.09f81ccf.svg";